import { Modal } from "@react-solutions-ui/findmore-ui";
import styles from "./EvaluationInfoModal.module.css";

interface EvaluationInfoModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function EvaluationInfoModal({
  isOpen,
  onClose,
}: EvaluationInfoModalProps) {
  if (!isOpen) return null;

  return (
    <Modal
      title="COMO FUNCIONA A TUA AVALIAÇÃO 360º"
      type="info"
      closeModalLabel="FECHAR"
      onCloseModal={onClose}
    >
      <div className={styles.modalContent}>
        <ul className={styles.stepsList}>
          <li className={styles.stepItem}>
            <span className={styles.stepText}>
              • Escolhe dois colegas e completa a tua autoavaliação.
            </span>
          </li>
          <li className={styles.stepItem}>
            <span className={styles.stepText}>
              • Os colegas, o manager e o cliente (quando aplicável) recebem
              um convite para te avaliar.
            </span>
          </li>
          <li className={styles.stepItem}>
            <span className={styles.stepText}>
              • No final, receberás um relatório completo com todo o feedback
              recolhido.
            </span>
          </li>
          <li className={styles.stepItem}>
            <span className={styles.stepText}>
              • O processo de avaliação tem a duração total de 30 dias.
              Receberás notificações por e-mail sempre que houver novas
              etapas.
            </span>
          </li>
        </ul>

        <div className={styles.importantSection}>
          <div className={styles.importantHeader}>
            <h3 className={styles.importantTitle}>Importante:</h3>
          </div>
          <div className={styles.importantContent}>
            <p>
              Incentiva os teus colegas a completarem a tua avaliação - embora
              o seu feedback seja valioso, a participação é opcional. O
              cliente, quando aplicável, também é convidado a participar, mas
              não é obrigatório que submeta o seu feedback.
            </p>
            <p>
              O processo pode ser encerrado mesmo que existam avaliações
              pendentes de colegas ou cliente.
            </p>
            <p>
              As únicas etapas obrigatórias a concluir dentro do prazo são: a
              tua autoavaliação, que deve ser completada por ti, e a avaliação
              dos teus líderes.
            </p>
          </div>
        </div>

        <div className={styles.textDeadline}>
          Após o prazo de 30 dias, o processo encerra automaticamente com base
          nas avaliações recebidas.
        </div>
      </div>
    </Modal>
  );
}
